import React from "react";
import ActionDropdown from "./ActionDropdown";

const TableRow = ({
  row,
  headers,
  rowKey,
  isDropdownOpen,
  toggleDropdown,
  onActionClick,
  rowIndex,
  rowClassName,
}) => {
  return (
    <tr
      className={`${
        rowIndex % 2 === 0 ? "bg-white" : "bg-white"
      } border-b border-gray-200 ${rowClassName}`}
    >
      {headers.map(({ key }, headerIdx) => (
        <td
          key={key}
          className={`py-2 px-4 ${
            headerIdx === 1 ? "cursor-pointer hover:underline" : ""
          }`}
          onClick={
            headerIdx === 1 ? () => onActionClick("View", row) : undefined
          }
        >
          {row[key]}
        </td>
      ))}
      <td className="py-2 px-4 text-start relative">
        <button
          className="text-gray-500 hover:text-gray-700"
          onClick={(e) => {
            e.stopPropagation();
            toggleDropdown(rowIndex);
          }}
          aria-label="Open actions menu"
        >
          <i className="fas fa-ellipsis-h"></i>
        </button>
        <ActionDropdown
          isOpen={isDropdownOpen}
          row={row}
          headers={headers}
          onActionClick={onActionClick}
          onClose={() => toggleDropdown(null)}
        />
      </td>
    </tr>
  );
};

export default TableRow;
